// Logos
export { default as Logos } from "./Logos";
export type { default as LogosProps } from "./LogosProps.interface";

// Logo
export { default as Logo } from "./components/Logo/Logo";
export type { default as LogoProps } from "./components/Logo/LogoProps.interface";